import { useState } from 'react'
import { Link } from 'react-router-dom'
import { useQuery } from '@tanstack/react-query'
import { apiClient } from '@/lib/api'
import { useT } from '@/i18n/I18nProvider'

interface User {
  id: string; email: string; name: string | null
  emailVerified: boolean; defaultTenantId: string | null; defaultRole: string | null
  lastSignInAt: string | null; createdAt: string
}

export function AdminUsersPage() {
  const t = useT()
  const [q, setQ] = useState('')
  const users = useQuery({
    queryKey: ['admin-users', q],
    queryFn: () => {
      const params = new URLSearchParams()
      if (q) params.set('q', q)
      return apiClient.get<{ data: User[] }>(`/admin/users?${params}`)
    },
  })

  return (
    <div>
      <h1 className="text-2xl font-semibold mb-4">{t('admin.users.title')}</h1>
      <input
        value={q}
        onChange={(e) => setQ(e.target.value)}
        placeholder={t('admin.users.search')}
        className="px-2 py-1 text-sm border rounded bg-transparent mb-4 w-64"
        style={{ borderColor: 'var(--color-border)' }}
      />
      {users.isLoading && <p>{t('common.loading')}</p>}
      {users.data && (
        <table className="w-full text-sm border-collapse">
          <thead>
            <tr className="text-left opacity-70">
              <th className="py-2 pr-4">{t('admin.users.column.email')}</th>
              <th className="py-2 pr-4">{t('admin.users.column.name')}</th>
              <th className="py-2 pr-4">{t('admin.users.column.role')}</th>
              <th className="py-2 pr-4">{t('admin.users.column.lastsignin')}</th>
              <th className="py-2 pr-4">{t('admin.users.column.created')}</th>
            </tr>
          </thead>
          <tbody>
            {users.data.data.map((u) => (
              <tr key={u.id} className="border-t" style={{ borderColor: 'var(--color-border)' }}>
                <td className="py-2 pr-4">
                  <Link to={u.id} className="hover:underline">{u.email}</Link>
                  {u.emailVerified && <span className="text-xs opacity-60 ml-1">✓</span>}
                </td>
                <td className="py-2 pr-4">{u.name ?? '—'}</td>
                <td className="py-2 pr-4">{u.defaultRole ?? '—'}</td>
                <td className="py-2 pr-4">{u.lastSignInAt ? new Date(u.lastSignInAt).toLocaleString() : '—'}</td>
                <td className="py-2 pr-4">{new Date(u.createdAt).toLocaleDateString()}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  )
}
